module.exports = __webpack_public_path__ + "img/illustration-element-01.93980cb8.svg";